/* tslint:disable */
/* eslint-disable */
/**
 * All APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface BeginChatRequest
 */
export interface BeginChatRequest {
    /**
     * 
     * @type {string}
     * @memberof BeginChatRequest
     */
    firstMessage?: string;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof BeginChatRequest
     */
    metadata?: { [key: string]: string; };
}

/**
 * Check if a given object implements the BeginChatRequest interface.
 */
export function instanceOfBeginChatRequest(value: object): value is BeginChatRequest {
    return true;
}

export function BeginChatRequestFromJSON(json: any): BeginChatRequest {
    return BeginChatRequestFromJSONTyped(json, false);
}

export function BeginChatRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): BeginChatRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'firstMessage': json['firstMessage'] == null ? undefined : json['firstMessage'],
        'metadata': json['metadata'] == null ? undefined : json['metadata'],
    };
}

export function BeginChatRequestToJSON(json: any): BeginChatRequest {
    return BeginChatRequestToJSONTyped(json, false);
}

export function BeginChatRequestToJSONTyped(value?: BeginChatRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'firstMessage': value['firstMessage'],
        'metadata': value['metadata'],
    };
}

